(() => {
  const form = document.querySelector('#SpInquiryForm');
  if (!form) return;

  const price = document.querySelector('[data-design-price]');
  const label = document.querySelector('[data-design-label]');
  const designOptions = [...form.querySelectorAll('[data-design-option]')];
  const patchType = form.querySelector('[data-patch-type]');
  const pantoneField = form.querySelector('[data-pantone-field]');
  const honeypot = form.querySelector('[data-honeypot]');

  const updateDesign = () => {
    const checked = designOptions.find(input => input.checked);
    if (!checked) return;
    if (price) price.textContent = `${checked.dataset.price} €`;
    if (label) label.textContent = checked.dataset.label || '';
    designOptions.forEach(input => input.closest('.sp-design-option')?.classList.toggle('is-selected', input.checked));
  };

  const updatePantone = () => {
    if (!patchType || !pantoneField) return;
    const rubber = patchType.value === 'Rubber / PVC';
    pantoneField.classList.toggle('is-recommended', rubber);
    const span = pantoneField.querySelector('span');
    if (span) span.innerHTML = rubber
      ? 'Pantone-/PMS-Codes oder Farbwünsche <small>empfohlen bei Rubber / PVC</small>'
      : 'Pantone-/PMS-Codes oder Farbwünsche <small>optional</small>';
  };

  designOptions.forEach(input => input.addEventListener('change', updateDesign));
  patchType?.addEventListener('change', updatePantone);
  updateDesign();
  updatePantone();

  form.addEventListener('submit', event => {
    if (honeypot?.value) {
      event.preventDefault();
      form.reset();
    }
  });
})();
